import React from 'react';
import * as Styles from './PlansList.styles';
import PlanCard from '../PlanCard/PlanCard';
import PlanCarousel from '../PlanCarousel/PlanCarousel';

const PlansList = ({
  currentProduct,
  currentPlanResourcesList,
  processedPlans,
  locale,
  isMobile,
  getButtonState,
  onSelectPlan,
}) => {
  const currentPlan = {
    productId: 'current',
    productName: currentProduct?.productName,
    resourcesList: currentPlanResourcesList,
  };

  return (
    <Styles.SectionPlans data-testid="vpsoci-upgrade-listing-plans">
      <Styles.PlanListTitle data-testid="vpsoci-upgrade-listing-plan-list-title">
        {locale.title}
      </Styles.PlanListTitle>

      <Styles.PlansRow data-testid="vpsoci-upgrade-listing-plans-row">
        {currentPlan && (
          <PlanCard
            plan={currentPlan}
            isCurrent
            locale={locale}
          />
        )}

        <PlanCarousel
          plans={processedPlans}
          locale={locale}
          isMobile={isMobile}
          getButtonState={getButtonState}
          onSelectPlan={onSelectPlan}
        />
      </Styles.PlansRow>
    </Styles.SectionPlans>
  );
};

export default PlansList;
